import { Routes, Route, useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import PageLoader from "./components/PageLoader";
/* =========================
   Lazy Loaded Pages
========================= */

// Home & Contact
const Home = lazy(() => import("./components/Home"));
const ContactUs = lazy(() => import("./components/ContactUs"));

// Who Are We
const OurPurpose = lazy(() =>
  import("./components/WhoAreWe/OurPurpose")
);
const OurTeam = lazy(() =>
  import("./components/WhoAreWe/OurTeam")
);

// What We Do
const Events = lazy(() =>
  import("./components/WhatWeDo/Events")
);
const OurServices = lazy(() =>
  import("./components/WhatWeDo/Services")
);

// Colleges
const CollegesGrid = lazy(() =>
  import("./components/CollegesGrid")
);

// Who We Help
const ForStudents = lazy(() =>
  import("./components/WhoWeHelp/Students")
);
const EdTechs = lazy(() =>
  import("./components/WhoWeHelp/EdTech")
);
const Universities = lazy(() =>
  import("./components/WhoWeHelp/Universities")
);
const Careers = lazy(()=>import("./components/WhoAreWe/Careers"))

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

/* =========================
   Loader Component
========================= */

// const PageLoader = () => (
//   <div
//     className="d-flex justify-content-center align-items-center"
//     style={{ minHeight: "60vh" }}
//   >
//     <div className="text-center">
//       <div className="spinner-border text-primary" />
//       <p className="mt-3">Loading page...</p>
//     </div>
//   </div>
// );

/* =========================
   App Component
========================= */

function App() {
  return (
    <>
      <ScrollToTop />
      <NavBar />
      <Suspense fallback={<PageLoader/>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactUs />} />

          {/* Who Are We */}
          <Route path="/who-are-we/purpose" element={<OurPurpose />} />
          <Route path="/who-are-we/team" element={<OurTeam />} />
          <Route path="/who-are-we/careers" element = {<Careers/>} />

          {/* What We Do */}
          <Route path="/what-we-do/events" element={<Events />} />
          <Route path="/what-we-do/our-services" element={<OurServices />} />

          {/* Colleges */}
          <Route path="/colleges" element={<CollegesGrid />} />

          {/* Who We Help */}
          <Route path="/who-we-help/students" element={<ForStudents />} />
          <Route path="/who-we-help/edtechs" element={<EdTechs />} />
          <Route path="/who-we-help/universities" element={<Universities />} />
        </Routes>
      </Suspense>

      {/* Always Loaded */}
      <Footer />
    </>
  );
}

export default App;
